const handleUrl = () => {
  return process.env.REACT_APP_SERVER
}

const url = handleUrl();

export default url
